import styled from 'styled-components'

import { Image } from 'src/components/Ant'

const WrapSectionReceipts = styled.div`
  #content {
    display: inline-flex;
    flex-wrap: wrap;
  }
  #block {
    align-content: center;
    border-style: groove;
    border-width: 1px;
    font-size: 12px;
    height: 445px;
    margin: 0 auto;
    padding: 1px;
  }
`

const WrapSectionReceipt = styled(Image)`
  text-align: center;
  max-width: 350px;
  max-height: 420px;
  width: auto;
  height: auto;
`

export { WrapSectionReceipts, WrapSectionReceipt }
